import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Fishing(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M10 4a1 1 0 00-2 0v2.17a3.001 3.001 0 000 5.66V17a2 2 0 11-4 0v-3.382l.553.276a1 1 0 10.894-1.788l-2-1A1 1 0 002 12v5a4 4 0 008 0v-5.17a3.001 3.001 0 000-5.66V4zm0 5a1 1 0 11-2 0 1 1 0 012 0zm8.055-5.832a1 1 0 00-1.11 0C15.21 4.325 13 7.117 13 11c0 3.226 1.52 5.332 2.985 6.6l-1.692 1.693a1 1 0 001.414 1.414l1.793-1.793 1.793 1.793a1 1 0 001.414-1.414L19.015 17.6C20.48 16.332 22 14.226 22 11c0-3.883-2.21-6.675-3.945-7.832zM20 11c0 2.64-1.288 4.29-2.5 5.262C16.288 15.289 15 13.639 15 11c0-2.681 1.324-4.69 2.5-5.736C18.676 6.31 20 8.32 20 11zm-2-1a1 1 0 100-2 1 1 0 000 2z",
    clipRule: "evenodd"
  }));
}

export default Fishing;